import { StoreData } from "../../data/store/store.data";
import { ApiConfig } from "../../lib/request/api-config";

export const getStoreBasicApi: ApiConfig = {
  url: "/wx-api/store/basic",
  method: "get",
};

export interface GetStoreBasicRes {
  total: number;

  dataList: StoreData[];
}
